import { CREATE_ADDSCRORECARD_SUCCESS, CREATE_ADDSCRORECARD_LOADING, CREATE_ADDSCRORECARD_ERROR, CREATE_TOURNAMENT_SUCCESS, CREATE_TOURNAMENT_ERROR, CREATE_TOURNAMENT_LOADING } from "../../../constant/actionTypes";

const createPotyReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_TOURNAMENT_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_TOURNAMENT_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case CREATE_TOURNAMENT_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createPotyReducer;